<template>

    <div class="view" id="chat-interface">
        
        <ChatTranscript v-if="chatReady" @new-message="scrollToBottom"></ChatTranscript>

        <div class="input-wrapper">

            <ChatClosed v-if="chatClosed"></ChatClosed>

            <ChatInput v-else></ChatInput>

        </div>

    </div>

</template>


<script>
    import ChatTranscript from "./partials/transcript.vue"
    import ChatInput from "./partials/input.vue"
    import ChatClosed from "./partials/chatclosed.vue"
    
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'ChatInterface',
        components: {
            ChatInput,
            ChatTranscript,
            ChatClosed,
        },
        async beforeMount() {
            await this.buildLiveChatApp();
        },
        mounted() {
            this.scrollToBottom();
        },
        computed: {
            ...mapGetters([
                "appLoading", 
                "currentChat",
                "currentChatMessages",
            ]),
            chatReady() {
                return !this.appLoading && this.currentChat.isLoaded;
            },
            chatClosed() {
                return this.currentChat.isOpen === false;
            },
        },
        methods: {
            ...mapActions([
                "incrementAppLoader",
                "decrementAppLoader",
                "getLiveChatApp",
            ]),
            scrollToBottom() {
                const scrollToPosition = (document.body.scrollHeight + 1000) || (document.documentElement.scrollHeight + 1000);
                window.scrollTo(0, scrollToPosition);
            },
            signalResetApp() {
                this.$emit('resetApp');
            },
            async buildLiveChatApp() {

                this.incrementAppLoader();

                await this.getLiveChatApp()

                this.decrementAppLoader();
            },
        },
        watch: {
            chatReady: {
                immediate: true,
                handler() {
                    this.scrollToBottom();
                }
            },
            currentChatMessages: {
                deep: true,
                immediate: true,
                handler() {
                    this.scrollToBottom();
                }
            }
        }
    }
</script>

<style lang="scss">
@import "./chat.scss";
</style>